import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function HandleError({ errorCode }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (errorCode) {
      navigate(`/error?code=${errorCode ? errorCode : "400"}`, {});
    }
  }, []);

  return null;
}
